import InfoIcon from '@mui/icons-material/Info'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { formatBigMoney, formatInteger } from '../../../packages/utils/numberFormatters'
import { DynamicIconButton } from '../../../utils/tooltip/DynamicIconButton'
import { FactsTable, FactsTableRow } from '../../components/FactsTable'
import { useLoaderData } from 'react-router-dom'
import { CompanyEntity } from 'types/CompanyEntity'

function CompanyAbout() {
    const company = useLoaderData()
    const { i18n } = useTranslation()
    const locale = i18n.language

    if (!company) return null

    const tableRows = []

    tableRows.push(
        <FactsTableRow key={tableRows.length} label='Bolagsnamn'>
            {company.name}
        </FactsTableRow>,
    )

    tableRows.push(
        <FactsTableRow key={tableRows.length} label='Orgnr'>
            {company.registrationNumber}
        </FactsTableRow>,
    )

    tableRows.push(
        <FactsTableRow key={tableRows.length} label='Bransch'>
            {company.sector1} <br />
            {company.sector2} <br />
            {company.sector3}
        </FactsTableRow>,
    )

    tableRows.push(
        <FactsTableRow
            key={tableRows.length}
            label='Totalt antal aktier'
            IconComponent={
                <DynamicIconButton
                    title='Det totala antalet aktier för samtliga aktieslag plus maximal utspädning från hypotetiskt fulltecknade emissioner.'
                    IconComponent={InfoIcon}
                    placement='top'
                    padding='0px 4px'
                />
            }
        >
            {formatInteger(company.millistreamTotalshares, { locale })}
        </FactsTableRow>,
    )

    tableRows.push(
        <FactsTableRow
            key={tableRows.length}
            label='Börsvärde'
            IconComponent={
                <DynamicIconButton
                    title='Börsvärde baseras på totalt antal aktier plus maximal utspädning från hypotetiskt fulltecknade emissioner.'
                    IconComponent={InfoIcon}
                    placement='top'
                    padding='0px 4px'
                />
            }
        >
            {company.marketcap
                ? formatBigMoney(company.marketcap, {
                      locale,
                      currencySymbol: company.currency,
                  })
                : '-'}
        </FactsTableRow>,
    )

    return <FactsTable rows={tableRows} />
}

export default CompanyAbout
